import React, { useState } from 'react';
import { Box, Button, Icon, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile'

import DialogBase from './DialogBase';

interface DialogUploadGeoPackageProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: (file: File) => void;
}

const DialogUploadGeoPackage: React.FC<DialogUploadGeoPackageProps> = ({
  open,
  title,
  onClose,
  onSubmit,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.name.toLowerCase().endsWith('.gpkg')) {
        setSelectedFile(file);
        setError(null);
      } else {
        setError('Alleen .gpkg bestanden zijn toegestaan.');
        setSelectedFile(null);
      }
    }
  };

  const handleSubmit = () => {
    if (!selectedFile) {
      setError('Selecteer een .gpkg bestand.');
      return;
    }
    onSubmit(selectedFile);
    handleClose();
  };

  const handleClose = () => {
    setSelectedFile(null);
    onClose();
  };

  return (
    <DialogBase
      open={open}
      title={title}
      contentText="Selecteer een GeoPackage (.gpkg) bestand om te uploaden."
      onClose={handleClose}
      onConfirm={handleSubmit}
      confirmButtonText="Uploaden"
      confirmButtonIcon={<Icon>upload</Icon>}

    >
      <Box mt={2}>
        <Button
          variant="outlined"
          component="label"
          startIcon={<UploadFileIcon />}
        >
          Kies bestand
          <input
            type="file"
            hidden
            accept=".gpkg"
            onChange={handleFileChange}
          />
        </Button>

        {selectedFile && (
          <Typography mt={1}>
            Geselecteerd: <strong>{selectedFile.name}</strong>
          </Typography>
        )}

        {error && (
          <Typography color="error" mt={1}>
            {error}
          </Typography>
        )}
      </Box>
    </DialogBase>
  );
};

export default DialogUploadGeoPackage;
